/**
 * NOTE: `applicationType` always be `BROWSER` for our apps.
 */
export function getAppInstance() {
    return {
        applicationType: 'BROWSER',
        userAgent: navigator.userAgent
    };
}
